module.exports = "/legacy/1fdce856015c10ffa8cf6d175d48cbd7.svg";